// extracted by mini-css-extract-plugin
module.exports = {"container":"c6e8ba5398--container--IU9GC","slides":"c6e8ba5398--slides--2ORXX","slides--noTransform":"c6e8ba5398--slides--noTransform--3tXo3","slide":"c6e8ba5398--slide--2UrIE"};